module.exports = require("simple-git");